module.exports = __webpack_public_path__ + "static/img/sdjqbapk.493c086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdjqbapk.jpg
// module id = MHff
// module chunks = 16